import Divider from "@galaxy-io/dls/layout/Divider";
import Flex, { AlignItems, JustifyContent } from "@galaxy-io/dls/layout/Flex";
import type { ReactNode } from "react";

export function BaseToolbar({
  leadingActions,
  trailingActions,
}: {
  leadingActions?: ReactNode;
  trailingActions?: ReactNode;
}) {
  return (
    <>
      <Flex
        alignItems={AlignItems.CENTER}
        justifyContent={JustifyContent.SPACE_BETWEEN}
        gap={8}
        padding={[8, 12]}
        minWidth={0}
        shrink={0}
        overflow="auto"
        fillWidth
      >
        <Flex alignItems={AlignItems.CENTER} gap={8} grow={1} minWidth={220}>
          {leadingActions}
        </Flex>
        {trailingActions && (
          <Flex alignItems={AlignItems.CENTER} gap={8} shrink={0}>
            {trailingActions}
          </Flex>
        )}
      </Flex>
      <Divider />
    </>
  );
}
export function Toolbar({
  children,
  trailingActions,
}: {
  children?: ReactNode;
  trailingActions?: ReactNode;
}) {
  return <BaseToolbar leadingActions={children} trailingActions={trailingActions} />;
}
